// extracted by mini-css-extract-plugin
export default {"accountHeader":"wi-z","newDesignAccountHeader":"xi-z","primeBadge":"yi-z","logout":"zi-z"};